import React from 'react';
import ReactDOM from 'react-dom';
import Axios from 'axios';
import { isNullOrUndefined } from 'util';
import config from 'react-global-configuration';
import AlertMessageDismissible from './AlertMessageDismissible';
import { decodeHtml } from './Helpers/ContentHelpers';

class FormForgottenPassword extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            message: {
                text: '',
                type: 'danger',	// info, danger, warning, success
                wrapper: 'd-none'
            },
            form: {
                email: ''
            },
            touched: {
                email: false
            },
            formSubmitted: false,
            formSubmitting: false
        };
    }

    handleOnChangeFormInput = (e) => {
        const name = e.target.name;
        const valueOverride = e.target.dataset.valueoverride;
        var value = isNullOrUndefined(valueOverride) ? e.target.value : valueOverride;

        this.setState({
            form: { ...this.state.form, [name]: value }
        });
    }

    handleOnBlurFormInput = () => (e) => {	// double arrow function, otherwise the onBlur event goes into an infinite loop.
        const name = e.target.name;
        this.setState({
            touched: { ...this.state.touched, [name]: true }	// for everything in state.touched, update "field" value.
        });
    }

    handleOnClickSubmit = (e) => {
        e.preventDefault();
        if (!isNullOrUndefined(this.state.formSubmitted) && this.state.formSubmitted === true) {
            return;
        }

        // touch everything to validate everything.
        this.setState({
            formSubmitted: true,
            touched: {
                email: true
            }
        }, () => {
            var errors = this.validate(this.state.form);
            if (Object.values(errors).join('').length > 0) {
                //console.log("we have validation errors");
                this.setState({
                    formSubmitted: false,
                    formSubmitting: false
                });
            } else {
                var CurrentNodeID = config.get("CurrentNodeID");

                var bodyFormData = new FormData();
                bodyFormData.append('CurrentNodeID', CurrentNodeID);
                bodyFormData.append('Email', this.state.form.email);
                this.setState({
                    formSubmitting: true
                });

                Axios({
                    method: 'post',
                    config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } },
                    url: '/umbraco/surface/ForgottenPassword/SendForgottenPasswordEmail',
                    data: bodyFormData
                })
                    .then(response => response.data)
                    .then(
                        (response) => {
                            this.setState({
                                message: {
                                    type: response.Status,
                                    text: response.Message,
                                    wrapper: ""
                                },
                                form: {
                                    email: response.Status === "success" ? '' : this.state.form.email
                                },
                                touched: {
                                    email: false
                                },
                                formSubmitted: false,
                                formSubmitting: false
                            });
                        },
                        // Note: it's important to handle errors here
                        // instead of a catch() block so that we don't swallow
                        // exceptions from actual bugs in components.
                        (error) => {
                            this.setState({
                                isLoaded: true,
                                error
                            });
                        }
                    );
            }
        });

    }


    validate = (form) => {
        const errors = {		// error messages.
            email: ''
        };

        if (this.state.touched.email) {
            const reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            if (form.email.length === 0) {
                errors.email = 'Email is required';
            } else if (!reg.test(form.email)) {
                errors.email = 'Invalid email';
            };
        };

        return errors;
    }

    handleOnClickAlert = () => {
        this.setState({ message: { text: '', type: 'danger' } })
    }


    render = () => {

        const errors = this.validate(this.state.form);

        return (
            <form autoComplete="off">
                <div className="row">
                    <div className="col-12 col-lg-8 offset-lg-2">
                    </div>
                </div>
                <div className="row">
                    <div className="col-12 col-sm-8 offset-sm-2 col-lg-6 offset-lg-3">
                        <div className="card my-5 cardShadow">
                            <div className="card-body px-3 px-sm-5 pt-4">
                                <div className="row">
                                    <div className="col-12 text-center">
                                        <div className="lead">Forgotten Password</div>
                                        <hr className="mt-1 mb-3" />
                                        <AlertMessageDismissible text={this.state.message.text} type={this.state.message.type} onClick={this.handleOnClickAlert} />
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-12">
                                        <div className={this.state.message.type === "success" && this.state.message.text !== "" ? "" : "d-none"}>
                                            <div className="text-center" dangerouslySetInnerHTML={{ __html: decodeHtml(renderedContent.confirmationMessage) }} />
                                        </div>
                                        <div className={this.state.message.type === "success" && this.state.message.text !== "" ? "d-none" : ""}>
                                            <div className="text-center" dangerouslySetInnerHTML={{ __html: decodeHtml(renderedContent.intro) }} />
                                            <div className="row">
                                                <div className="col-12 col-md-10 offset-md-1 form-group">
                                                    <label htmlFor="email">Email address</label>

                                                    <input className={this.state.touched.email && errors.email !== '' ? "form-control is-invalid" : "form-control"} type="email" id="email" name="email" placeholder="Email address" maxLength="100" onBlur={this.handleOnBlurFormInput()} onChange={this.handleOnChangeFormInput} autoComplete="off" value={this.state.form.email} />
                                                    {
                                                        !isNullOrUndefined(errors.email) && errors.email !== '' &&
                                                        <div className="invalid-feedback">{errors.email}</div>
                                                    }
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-12 col-md-10 offset-md-1 form-group">
                                                    <button type="submit" className="btn btn-clr-secondary w-100 mt-3" onClick={this.handleOnClickSubmit}><span className={this.state.formSubmitting ? "rippler mr-2" : "rippler d-none"}></span>Recover Password</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        );
    }
}

ReactDOM.render(
    <FormForgottenPassword />, document.getElementById('elementForForgottenPassword')
);

//<Input type="email" id="email" name="email" placeholder="Email address" maxLength="100" valid={this.state.touched.email && errors.email === ''} invalid={errors.email !== ''} onBlur={this.handleOnBlurFormInput()} onChange={this.handleOnChangeFormInput} />